import * as React from 'react';

import { cn } from '../lib/cn.js';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(
        'flex h-11 w-full rounded-sm border border-jq-border bg-jq-bg-overlay px-3 py-2',
        'font-sans text-[15px] text-jq-fg-1 placeholder:text-jq-fg-3',
        'transition-colors duration-200 ease-jq',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-jq-action-accent/60 focus-visible:ring-offset-2 focus-visible:ring-offset-jq-bg-base',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'file:border-0 file:bg-transparent file:text-[14px] file:font-medium',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';

export { Input };
